import { useMemo } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, X } from "lucide-react";

export const RANGE_OPTIONS = [
  ["all", "All time"], ["today", "Today"], ["week", "This Week"],
  ["month", "This Month"], ["last30", "Last 30 Days"], ["custom", "Custom Range"],
];

export function rangeStart(key, from) {
  const now = new Date();
  if (key === "today") { const d = new Date(now); d.setHours(0, 0, 0, 0); return d; }
  if (key === "week") { const d = new Date(now); const wd = (d.getDay() + 6) % 7; d.setDate(d.getDate() - wd); d.setHours(0, 0, 0, 0); return d; }
  if (key === "month") return new Date(now.getFullYear(), now.getMonth(), 1);
  if (key === "last30") { const d = new Date(now); d.setDate(d.getDate() - 30); return d; }
  if (key === "custom" && from) return new Date(from);
  return null;
}

export function useDateFilter(rows, dateField, range, from, to) {
  return useMemo(() => {
    if (range === "all") return rows;
    const start = rangeStart(range, from);
    const end = range === "custom" && to ? new Date(new Date(to).getTime() + 86400000) : new Date();
    return rows.filter((r) => {
      const v = r[dateField];
      if (!v) return false;
      const t = new Date(v).getTime();
      return (!start || t >= start.getTime()) && t <= end.getTime();
    });
  }, [rows, dateField, range, from, to]);
}

export default function Filters({ search, setSearch, range, setRange, from, setFrom, to, setTo, onClear, placeholder }) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <div className="relative min-w-[200px] flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input data-testid="admin-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder={placeholder || "Search…"} className="rounded-full pl-9" />
      </div>
      <Select value={range} onValueChange={setRange}>
        <SelectTrigger data-testid="admin-date-range" className="h-9 w-auto rounded-full text-sm"><SelectValue /></SelectTrigger>
        <SelectContent>{RANGE_OPTIONS.map((o) => <SelectItem key={o[0]} value={o[0]}>{o[1]}</SelectItem>)}</SelectContent>
      </Select>
      {range === "custom" && (
        <>
          <Input data-testid="admin-date-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="h-9 w-auto rounded-full text-sm" />
          <Input data-testid="admin-date-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} className="h-9 w-auto rounded-full text-sm" />
        </>
      )}
      <Button variant="outline" size="sm" onClick={onClear} data-testid="admin-clear-filters" className="rounded-full"><X className="mr-1 h-3 w-3" /> Clear Filters</Button>
    </div>
  );
}
